// Tufts University's undergraduate majors (#2652). Read on 2026-10-01 from
// Tufts Admissions' official Majors and Minors finder
// (admissions.tufts.edu/academics/majors-and-minors), filtered to majors:
// every program it labels "Major" or "Major & Minor" is kept under the school
// that offers it as a major; minor-only programs are left out. The finder
// does not state the degree for most majors, so the degree is null there;
// the SMFA major leads to the Bachelor of Fine Arts, as its own entry says.
// Architectural Studies, Biotechnology and Computer Science are offered as
// majors by both Arts and Sciences and Engineering, so they appear in both
// groups. The KB's majors list was the starting point; the official list wins.
const majors = {
    "slug": "tufts-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in Tufts' official majors and minors list, grouped by the school that offers it. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "School of Arts and Sciences",
            "source": {
                "label": "Tufts Admissions, Majors and Minors",
                "url": "https://admissions.tufts.edu/academics/majors-and-minors/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": null
                },
                {
                    "name": "American Studies",
                    "degree": null
                },
                {
                    "name": "Ancient World Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Applied Environmental Studies",
                    "degree": null
                },
                {
                    "name": "Applied Mathematics",
                    "degree": null
                },
                {
                    "name": "Applied Physics",
                    "degree": null
                },
                {
                    "name": "Arabic: International Literary and Cultural Studies",
                    "degree": null
                },
                {
                    "name": "Archaeology",
                    "degree": null
                },
                {
                    "name": "Architectural Studies",
                    "degree": null
                },
                {
                    "name": "Astrophysics",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Biomedical Sciences",
                    "degree": null
                },
                {
                    "name": "Biopsychology",
                    "degree": null
                },
                {
                    "name": "Biotechnology",
                    "degree": null
                },
                {
                    "name": "Chemical Physics",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Child Study and Human Development",
                    "degree": null
                },
                {
                    "name": "Chinese: International Literary and Cultural Studies",
                    "degree": null
                },
                {
                    "name": "Civic Studies",
                    "degree": null
                },
                {
                    "name": "Climate Science",
                    "degree": null
                },
                {
                    "name": "Clinical Psychology",
                    "degree": null
                },
                {
                    "name": "Cognitive and Brain Sciences",
                    "degree": null
                },
                {
                    "name": "Community Health",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Earth Science",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Education",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "Film and Media Studies",
                    "degree": null
                },
                {
                    "name": "French & Francophone Cultural Studies",
                    "degree": null
                },
                {
                    "name": "French & Francophone Literary Studies",
                    "degree": null
                },
                {
                    "name": "German Studies",
                    "degree": null
                },
                {
                    "name": "German: International Literary and Cultural Studies",
                    "degree": null
                },
                {
                    "name": "Greek",
                    "degree": null
                },
                {
                    "name": "Greek and Latin",
                    "degree": null
                },
                {
                    "name": "Hebrew: International Literary and Cultural Studies",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "History of Art and Architecture",
                    "degree": null
                },
                {
                    "name": "Human Factors Psychology",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": null
                },
                {
                    "name": "International Literary and Cultural Studies",
                    "degree": null
                },
                {
                    "name": "International Literary and Visual Studies",
                    "degree": null
                },
                {
                    "name": "International Relations",
                    "degree": null
                },
                {
                    "name": "Italian Studies",
                    "degree": null
                },
                {
                    "name": "Japanese: International Literary and Cultural Studies",
                    "degree": null
                },
                {
                    "name": "Judaic Studies",
                    "degree": null
                },
                {
                    "name": "Latin",
                    "degree": null
                },
                {
                    "name": "Latin American Studies",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Middle Eastern Studies",
                    "degree": null
                },
                {
                    "name": "Music, Sound, and Culture",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Quantitative Economics",
                    "degree": null
                },
                {
                    "name": "Race, Colonialism, and Diaspora Studies",
                    "degree": null
                },
                {
                    "name": "Religion",
                    "degree": null
                },
                {
                    "name": "Romance Studies",
                    "degree": null
                },
                {
                    "name": "Russian and Eastern European Studies",
                    "degree": null
                },
                {
                    "name": "Russian: International Literary & Cultural Studies",
                    "degree": null
                },
                {
                    "name": "Science, Technology, and Society",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Spanish Cultural Studies",
                    "degree": null
                },
                {
                    "name": "Spanish Literature",
                    "degree": null
                },
                {
                    "name": "Theatre, Dance, and Performance Studies",
                    "degree": null
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of Engineering",
            "source": {
                "label": "Tufts Admissions, Majors and Minors",
                "url": "https://admissions.tufts.edu/academics/majors-and-minors/"
            },
            "majors": [
                {
                    "name": "Architectural Studies",
                    "degree": null
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": null
                },
                {
                    "name": "Biotechnology",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Data Science",
                    "degree": null
                },
                {
                    "name": "Electrical Engineering",
                    "degree": null
                },
                {
                    "name": "Engineering Physics",
                    "degree": null
                },
                {
                    "name": "Engineering Science",
                    "degree": null
                },
                {
                    "name": "Environmental Engineering",
                    "degree": null
                },
                {
                    "name": "Human Factors Engineering",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                },
                {
                    "name": "Public Health Engineering",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of the Museum of Fine Arts at Tufts",
            "source": {
                "label": "Tufts Admissions, Majors and Minors",
                "url": "https://admissions.tufts.edu/academics/majors-and-minors/"
            },
            "majors": [
                {
                    "name": "Interdisciplinary Art Major",
                    "degree": "BFA"
                }
            ]
        }
    ]
};

export default majors;
